<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="privacyTitle">
                  <h1>이메일 무단 수집 거부</h1>
                </div>
                <article class="privacyInner">
                    <div class="title">
                        <h3>이메일 무단 수집 거부</h3>
                    </div>
                    <div class="txtContainer">
                        <div class="txtContainerInner">
                          <p>
                            본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며 이를 위반 시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다.
                          </p>
                          <p>
                            안내 : newagingplatform@khu.ac.kr
                          </p>
                        </div>
                    </div>
                    <div class="btnBox">
                      <router-link to="/">확 인</router-link>
                    </div>
                </article>
            </div>
        </section> 
    </div>   
</template>

<script>
export default {
  name: 'privacyForm',
  data(){
    return{
    
    }
  },
}
</script>

<style scoped>
  .loginInner > h1 {
    color: #9E1915;
  }
  .privacyInner > .title {
    border-bottom: 4px solid #272727;
    padding: 20px 16px;
  }
  .privacyInner > .title > h3 {
    color: #272727;
  }
  .txtContainer {
    min-height: 680px;
    padding: 20px 0;
  }
  .txtContainerInner {
    height: 640px;
    overflow: auto;
  }
  .txtContainerInner p {
    padding-right: 10px;
    font-size: 20px;
  }
  .btnBox {
    padding: 84px 0 37px;
  }
  .btnBox a {
    margin: 0 auto;
    width: 144px;
    color: #FFF;
    background: #26336A;
    border-radius: 90px;
    height: 36px;
    padding: 0;
  }
  .txtContainerInner::-webkit-scrollbar {
      width: 7px;
  }
  .txtContainerInner::-webkit-scrollbar-thumb {
      background-color: rgba(38, 51, 106, 1);
      border-radius: 15px;
  }
  .txtContainerInner::-webkit-scrollbar-track {
      background-color: rgba(38, 51, 106, 0.4);
    }
</style>